import React from 'react';

export const PieTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0];
  return (
    <div className="stui-dashboard-visual-tooltip">
      <span className={`stui-legend-dot ${d.payload.colorClass || 'stui-c-slate'}`} />
      <strong>{d.name}</strong>: {d.value.toLocaleString()}
    </div>
  );
};

// `unit` names what the bars count.
export const BarTooltip = ({ active, payload, label, unit = 'drawings' }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="stui-dashboard-visual-tooltip">
      <strong>{label}</strong>: {payload[0].value} {unit}
    </div>
  );
};
